const SMU_TOKEN = "smu-token";
const SMU_USER = "smu-user";
const SMU_FILTER = "generalFilter";
const ITEMS_PER_PAGE = 10;
const SKIRTS_ID = 0;
const SMU_SELECTED_MENU = "smu-selected-menu";
const SMU_PRESERVE_PROMOTION_FILTERS = "smu-preserve-promotion-filters";

export { SMU_TOKEN, SMU_USER, ITEMS_PER_PAGE, SKIRTS_ID, SMU_FILTER, SMU_SELECTED_MENU, SMU_PRESERVE_PROMOTION_FILTERS};
